import axios from 'axios'
import $ from 'jquery';
import  {CORS_URL,API_URL} from "../config"


export  function isLogin() {
    let authToken = localStorage.getItem('authToken');

    let getData = {
        type : 'default',
        payload : {
            error : false
        }
    };
    if(typeof authToken === 'undefined' || authToken===null) {
        let data  = {
            "data" : {
                "name":"Niranjan",
                "phone_number" : "+911010101010",
                "firebase_token": "eyJhbGciOiJSUzI1NiIsImtpZCI6IjU0OGYzZjk4N2IxNzMxOWZlZDhjZDc2ODNmNTIyNWEyOTY0YzY5OWQiLCJ0eXAiOiJKV1QifQ.eyJpc3MiOiJodHRwczovL3NlY3VyZXRva2VuLmdvb2dsZS5jb20vZHJpYmJsZS05YTNmNiIsImF1ZCI6ImRyaWJibGUtOWEzZjYiLCJhdXRoX3RpbWUiOjE1NjAxNzEzNjksInVzZXJfaWQiOiJMR2FrSE1Jb29wUzFXTTJCMXN1TmU0cmhET2kxIiwic3ViIjoiTEdha0hNSW9vcFMxV00yQjFzdU5lNHJoRE9pMSIsImlhdCI6MTU2MDE3MTY3MywiZXhwIjoxNTYwMTc1MjczLCJwaG9uZV9udW1iZXIiOiIrOTE4MjkwMTg4NjM2IiwiZmlyZWJhc2UiOnsiaWRlbnRpdGllcyI6eyJwaG9uZSI6WyIrOTE4MjkwMTg4NjM2Il19LCJzaWduX2luX3Byb3ZpZGVyIjoicGhvbmUifX0.vF9lAdF1z4mRzO1EDNyOxuwcWS6wsi7mvAyQY0kdyllkEyLsGvnpLNRAGqzrvOGyElYVpMcPzS_5FA5CoVfe0k0PUsXs0nsY1eP0QHF7qx0qGy2TUq_FUKl1X-fAdfIAGWytOjwfH_MR1nct_IvjRj9Jx97iHIO0rGeXm7Hh0TscTPvvsrJztZgD5CUTwkV-B5sP9PGwGGescDV0pXYnJwI7J7I6toP4hOA8tjk76L1w9x9_bEGGRtFikGd151kvrrhbtZfm4hJaJ4BS5iTCtIpldmeQdWWgmoL1huqENeSGToSnE5TY4RSj68bCW9q1XfAeSPJKQdPPTTgsik3_CA",
                "device_type":"ANDROID",
                "app_version": "1.1.0",
                "fcm_token":"hsdfkhdy3uedks",
                "has_firebase_check":"false"
            }
        }
        /*$.ajax({
            url : CORS_URL+API_URL+'/global/test-login',
            crossDomain: true,
            contentType: 'application/json',
            type: "POST",
            data:JSON.stringify(data),
            success(response, textStatus, request) {
                if(response.success === true) {
                    localStorage.setItem('authToken',request.getResponseHeader('X-Authorization'));
                    let getData = {
                        type : 'userData',
                        payload : {
                            user : response.data,
                            error : false
                        }
                    }
                    return dispatch(getData)
                } else {
                    dispatch(showError());
                }
            },
            error() {
                dispatch(showError());
            }
        })*/
    }


}

export function showError(error= "Error!!") {
    return {
        type : 'Error',
        payload : {
            fixtureData : error,
            isLoaded : true,
            error : true
        }
    }
}